import React, { useEffect, useState, Suspense, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { RadioButton } from "primereact/radiobutton";

import getQuoteBanner from "../../assets/images/happy-couple-car-dealership-banner.7d041973b88880a5f1b6-min.png";
import reminderCalendar from "../../assets/images/reminder-calendar-icon.png";

import { getProfile, getVehicleInfo, storeCacheQuote, createEarlyRenewalReminder } from "../../utils/backend";
import FloatLabelInput from "../../components/FloatingLabel";
import useStoreCarPlan from "../../store/actions/store-car-quote-list";
import useStoreToken from "../../store/actions/store-token";
import useStoreVehicleInfo from "../../store/actions/store-vehicle-info";
import useGetVehicleInfo from "../../store/selectors/get-vehicle-info";
import FloatDateInput from "../../components/FloatDateInput";
import FloatingSelectIdentity from "../../components/FloatingSelectIdentity";
import useStoreCarPlanList from "../../store/actions/store-car-quote-list";

import useStoreCarAddOn from "../../store/actions/store-car-add-on";
import useStoreCarAddOnSelection from "../../store/actions/store-car-add-on-selection";
import useStoreCarQuoteList from "../../store/actions/store-car-quote-list";
import useStoreCarPlanQuote from "../../store/actions/store-car-plan-quote";

import "../../assets/styles/radio-button.css";
import postcodeData from '../../assets/data/postcode.json';
import Loader2 from "../../components/Loader2";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { useToast } from  "../../components/CustomToast";
import { Checkbox } from "primereact/checkbox";
import { BMKContext } from "../../components/Providers/BMK-provider";

const GetQuotes = () => {
	const { bmkData, setBMKData } = useContext(BMKContext);

	const [activeIndex, setActiveIndex] = useState(0);
	const [vehicleType, setVehicleType] = useState("");
	//const [ownershipType, setOwnershipType] = useState("Private");
	const [vehicleRegNo, setVehicleRegNo] = useState("");
	const [inceptionDate, setInceptionDate] = useState("");
	const [expiryDate, setExpiryDate] = useState("");
	const [email, setEmail] = useState("");
	const [idType, setIdType] = useState("nric");
	const [idNo, setIdNo] = useState("");
	const [dob, setDob] = useState("");
	const [age, setAge] = useState("");
	const [maritalStatus, setMaritalStatus] = useState("");
	const [ownerName, setOwnerName] = useState("");
	const [contactNumber, setContactNumber] = useState("");
	const [postcode, setPostcode] = useState("");
	const [businessRegId, setBusinessRegId] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const setVehicleInfo = useStoreVehicleInfo();
	const retrieveVehicleInfo = useGetVehicleInfo();
	const setCarQuoteList = useStoreCarPlanList();
	const storeToken = useStoreToken();
	const [message, setMessage] = useState("");
	const [isMessageVisible, setIsMessageVisible] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currPolExpiryDate, setCurrPolExpiryDate] = useState("");
	const [earliestRenewDate, setEarliestRenewDate] = useState("");
	const [cachedQuoteId, setCachedQuoteId] = useState("");
	const [ncdPerc, setNcd] = useState(0);
	// "Get reminded to renew your insurance" form (ACS Dashboard BRD 3 July 2026)
	const [reminderName, setReminderName] = useState("");
	const [reminderIdNo, setReminderIdNo] = useState("");
	const [reminderPhone, setReminderPhone] = useState("");
	const [reminderSubmitting, setReminderSubmitting] = useState(false);

	const [enable_bmk, set_enable_bmk] = useState(false);
	const [consent_bmk, set_consent_bmk] = useState(false);

	const handleCheckboxChange = (e) => {
		set_enable_bmk(e.checked);
		if(e.checked) {
			set_consent_bmk(false);
		}
	}

	const handleConsentChange = (e) => {
		set_consent_bmk(e.checked);
		if(e.checked) {
			set_enable_bmk(false);
		}
	}

	// Ansa-Support#46: the customer must make a deliberate BMK choice before we
	// quote. Leaving both boxes untouched used to submit as "no consent" — safe,
	// in that no JPJ call was made, but silent: nobody chose it, and there was
	// nothing to record either way. Every Get Quote button below is gated on this.
	const bmkChoiceMade = enable_bmk || consent_bmk;
	const vehicleInfo = useGetVehicleInfo();
	
	const { t, i18n } = useTranslation();

	const { showInfo, showWarn } = useToast();

	const [disabledInputs, setDisabledInputs] = useState({
    private: initializeInputState(),
    company: initializeInputState(),
    commercial: initializeInputState(),
	});

	function initializeInputState(disabled = false) {
    return {
        typePrivateCar: disabled,
        typeMotorCycle: disabled,
        vehicleRegNo: disabled,
        typeOfIdentity: disabled,
        idNo: disabled,
        dob: disabled,
        age: disabled,
        ownerName: disabled,
        postcode: disabled,
        typeCompanyVehicle: disabled,
        businessRegId: disabled,
        companyName: disabled,
        typeCommercialVehicle: disabled,
    };
	}

	const toggleDisabledInputs = (type, disabled) => {
    setDisabledInputs((prevState) => ({
        ...prevState,
        [type]: initializeInputState(disabled),
    }));
	};

	const [loadingApp, setLoadingApp] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => setLoadingApp(false), 1000);
		return () => clearTimeout(timer);
	}, []);

	const clearCarAddOn = useStoreCarAddOn();
	const clearCarAddOnSelection = useStoreCarAddOnSelection();
	const clearCarQuoteList = useStoreCarQuoteList();
	const clearCarPlanQuote = useStoreCarPlanQuote();

	const clearCacheAndState = () => {
		// Clear Redux store
		clearCarAddOn(null);
		clearCarAddOnSelection(null);
		clearCarQuoteList(null);
		clearCarPlanQuote(null);
	
		// Clear localStorage
		const cacheKeys = [
			"cachedAddress",
			"selectedVariant",
		];
		cacheKeys.forEach((key) => localStorage.removeItem(key));
	};

	const showErrorMessage = (msg) => {
		setMessage(msg);
		setIsMessageVisible(true);
	};

	const BottomMessagePopUp = React.lazy(() => import("../../components/BottomMessagePopUp"));

	const [token, setToken] = useState("");

	useEffect(() => {
		fetchData();
	}, [getProfile]);

	const idTypeOptions = [
		{ value: "nric", label: "NRIC" },
		{ value: "passport", label: "Passport" },
	];

	const maritalStatusOptions = [
		{ value: "M", label: t(`common.married`) },
		{ value: "S", label: t(`common.single`) },
		{ value: "D", label: t(`common.divorced`) },
		{ value: "W", label: t(`common.widowed`) },
	];

	// Function to determine vehicle type
	const determineVehicleType = (veh_type, ownership_type) => {
		if (veh_type === "car" && ownership_type === "I") {
			return t(`auto.privateCar`);
		}
		if (veh_type === "motorcycle" && ownership_type === "I") {
			return t(`auto.motorcycle`);
		}
		if (veh_type === "car" && ownership_type === "B") {
			return t(`auto.commercialCar`);
		}
		if (veh_type === "motorcycle" && ownership_type === "B") {
			return t(`auto.motorcycle`);
		}
		return ""; // Default fallback if conditions are not met
	};

	useEffect(() => {
		if (retrieveVehicleInfo) {
			const { veh_type, ownership_type } = retrieveVehicleInfo;
			setVehicleType(determineVehicleType(veh_type, ownership_type));
			setVehicleRegNo(retrieveVehicleInfo?.reg_no || "");
			setIdNo(retrieveVehicleInfo?.id_no || "");
			setIdType(retrieveVehicleInfo?.id_type || "");
			setOwnerName(retrieveVehicleInfo?.owner_name || "");
			setContactNumber(retrieveVehicleInfo?.hphoneno || "");
			setPostcode(retrieveVehicleInfo?.postcode || "");
			setMaritalStatus(retrieveVehicleInfo?.marital_status || "");
		}
		console.log("Retrieved vehicle info:", retrieveVehicleInfo);
		
	}, [retrieveVehicleInfo]);

	const [profileData, setProfileData] = useState({});

	useEffect(()=> {
		if (enable_bmk) {
			if (activeIndex===0) {
				setIdType(profileData?.id_type || "");
				setIdNo(profileData?.id_no || "");
				if (!profileData?.id_no) {
					showErrorMessage("Please update your NRIC/Passport number in the profile section")
				}
			}
		}
	},[enable_bmk])

	const fetchData = async () => {
		const queryParameters = new URLSearchParams(window.location.search);
		const tokenParam = queryParameters.get("token");

		storeToken(tokenParam);
		setToken(tokenParam);

		if (tokenParam) {
			const response = await getProfile(tokenParam);
			if (response.success) {
				// BRD 03-Jul-2026: do NOT auto-populate Owner Name / Identification
				// Number / ID Type from the logged-in user's profile. The vehicle
				// owner may differ from the account holder, and auto-seeding here
				// also clobbered the user's typed values when navigating back from a
				// later step (the retrieveVehicleInfo redux restore ran first, then
				// this async profile fetch overwrote it). Profile data is still kept
				// for the BMK consent flow + the reminder email below.
				if (response.data.email) {
					setEmail(response?.data?.email);
				}

				setProfileData(response.data);

				const today = new Date();
				today.setHours(today.getHours() + 8);

				const inception_date = today.toISOString().split("T")[0];
				const expiry_date = new Date(today);
				expiry_date.setFullYear(expiry_date.getFullYear() + 1);
				expiry_date.setDate(expiry_date.getDate() - 1);

				setInceptionDate(inception_date);
				setExpiryDate(expiry_date.toISOString().split("T")[0]);
			}
		}
	};

	const handleVehRegNo = (e) => {
		const value = e.target.value;
		const formattedValue = value.replace(/\s+/g, '').replace(/\W/g, '').toUpperCase();
		setVehicleRegNo(formattedValue);
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		if (idType === 'nric' || idType === 'NRIC') {
			const numbersOnly = value.replace(/[^\d]/g, '');
			if (numbersOnly.length <= 12) {
				setIdNo(numbersOnly);
			}
		} else {
			setIdNo(value);
		}
	};

	const handlePostcodeChange = (e) => {
		const value = e.target.value;

		// Only allow numbers and ensure it doesn't exceed 5 characters
		const numbersOnly = value.replace(/[^\d]/g, '');
		if (numbersOnly.length <= 5) {
			setPostcode(numbersOnly);
		}
	};

	// Name fields: allow only the characters the backend accepts for a
	// name (mirror of full_name validation:
	// /^[\p{L}\p{N}\s.,:;!?()'"\-_\/+#@&%]{1,50}$/u), auto-uppercased.
	const NAME_DISALLOWED = /[^\p{L}\p{N}\s.,:;!?()'"\-_\/+#@&%]/gu;
	const handleNameChange = (setter) => (e) => {
		const cleaned = e.target.value.replace(NAME_DISALLOWED, "").slice(0, 50);
		setter(cleaned.toUpperCase());
	};

	// Owner's contact number: digits only.
	const handleContactNumberChange = (e) => {
		const digits = e.target.value.replace(/[^\d]/g, "").slice(0, 15);
		setContactNumber(digits);
	};

	const isPostcodeValid = (postcode) => {
		return postcode.length === 5;
	};

	const isNRICValid= (idNo) => {
		return idNo.length === 12;
	};

	const isPassportValid = (idNo) => {
		return idNo.length >= 8 && idNo.length <= 12;
	};	  
	
	const setDOBFromNric = (nric) => {
		if (!nric || nric.length < 6) return null;

		const year = parseInt(nric.slice(0, 2), 10);
		const month = parseInt(nric.slice(2, 4), 10) - 1;
		const day = parseInt(nric.slice(4, 6), 10);

		const fullYear = year >= 50 ? 1900 + year : 2000 + year;

		return new Date(fullYear, month, day);
	};

	const onTabChange = (e) => {
		setActiveIndex(e.index);

		// const ownership =
		// 	e.index === 0 ? "Private" : e.index === 1 ? "Company" : "Commercial";
		// setOwnershipType(ownership);

		// clearFields() resets idType, so set the per-tab default AFTER it.
		clearFields();
		setIdType(
			e.index === 1 || e.index === 2 ? "business" : "nric"
		);
		fetchData();
	};

	const handleIdTypeSelectChange = (e) => {
		setIdType(e.target.value);
		setIdNo("");
		setDob("");
		setAge("");
	};

	const handleMaritalStatusSelectChange = (e) => {
		setMaritalStatus(e.target.value);
	};

	const calculateAge = (dob) => {
		if (!dob) return ''; // Return empty if dob is not selected
		const birthDate = new Date(dob);
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
		  age--; // Adjust age if the birthday hasn't occurred this year
		}
		return age >= 0 ? age : 0;
	};
	  

	const clearFields = () => {
		//setOwnershipType("Private");
		setVehicleType("");
		setVehicleRegNo("");
		setIdNo("");
		setIdType("");
		setOwnerName("");
		setBusinessRegId("");
		setCompanyName("");
		setPostcode("");
		setDob("");
    	setAge("");
		setMaritalStatus("");

		setVehicleInfo(null);
		setOwnerName(ownerName);
	};

	// const isValidPostcode = (postcode) => {
	// 	const postcodeStr = String(postcode).replace(/^0+/, "");
	// 	const postcodeInt = parseInt(postcodeStr, 10);
	
	// 	if (isNaN(postcodeInt) || postcodeInt < 1000 || postcodeInt > 99999) {
	// 		return false;
	// 	}
	
	// 	const invalidPostcodes = [
	// 		11111, 99999, 55555, 88888, 66666, 99900 // Known invalid postcodes
	// 	]; // List of postcodes that should be invalid
	// 	if (invalidPostcodes.includes(postcodeInt)) {
	// 		return false;
	// 	}
	
	// 	// List of valid postcode ranges for each state in Malaysia
	// 	const stateMap = [
	// 		{ code: "B", ranges: [[40000, 48300], [63000, 68100]] }, // Selangor
	// 		{ code: "T", ranges: [[20000, 24300]] }, // Terengganu
	// 		{ code: "Q", ranges: [[93000, 98859]] }, // Sarawak
	// 		{ code: "S", ranges: [[88000, 91309]] }, // Sabah
	// 		{ code: "K", ranges: [[5000, 9810]] }, // Kedah
	// 		{ code: "D", ranges: [[15000, 18500]] }, // Kelantan
	// 		{ code: "N", ranges: [[70000, 73509]] }, // Negeri Sembilan
	// 		{ code: "P", ranges: [[10001, 14399]] }, // Penang (Adjusted range to exclude 11111)
	// 		{ code: "J", ranges: [[79000, 86900]] }, // Johor
	// 		{ code: "M", ranges: [[75000, 78309]] }, // Melaka
	// 		{ code: "R", ranges: [[1000, 2999]] }, // Perlis
	// 		{ code: "A", ranges: [[30000, 36810]] }, // Perak
	// 		{ code: "C", ranges: [[25000, 28800], [39000, 39200], [49000, 49000], [69000, 69000]] }, // Pahang
	// 		{ code: "W", ranges: [[50000, 60000]] }, // Kuala Lumpur
	// 		{ code: "L", ranges: [[87000, 87033]] }, // Labuan
	// 		{ code: "F", ranges: [[62000, 62999]] }, // Putrajaya
	// 	];
	
	// 	// Loop through the states and their respective postcode ranges
	// 	for (const { ranges } of stateMap) {
	// 		for (const [start, end] of ranges) {
	// 			// If the postcode is within any of the ranges, it's valid
	// 			if (postcodeInt >= start && postcodeInt <= end) {
	// 				return true;
	// 			}
	// 		}
	// 	}
	
	// 	return false; // If no valid range matched, it's an invalid postcode
	// };

	const isValidPostcode = (postcode) => {
		const postcodeStr = String(postcode).replace(/^0+/, ""); // Remove leading zeros
		const postcodeInt = parseInt(postcodeStr, 10);
	
		if (isNaN(postcodeInt) || postcodeInt < 1000 || postcodeInt > 99999) {
			return false;
		}
	
		const invalidPostcodes = [
			11111, 99999, 55555, 88888, 66666, 99900
		]; // List of known invalid postcodes
	
		if (invalidPostcodes.includes(postcodeInt)) {
			return false;
		}
	
		// Extract all valid postcodes from the JSON file
		const validPostcodes = new Set();
		
		postcodeData.state.forEach(state => {
			state.city.forEach(city => {
				city.postcode.forEach(pc => validPostcodes.add(parseInt(pc, 10)));
			});
		});
	
		// Check if the given postcode exists in the valid postcode list
		return validPostcodes.has(postcodeInt);
	};

	function isDateValid(dateStr) {
		return !isNaN(new Date(dateStr));
	}

	const handleButtonClick = async (e) => {
		e.preventDefault();

		const activeTypes = ["private", "company", "commercial"];
		const activeType = activeTypes[activeIndex] || "private";

		if (retrieveVehicleInfo && retrieveVehicleInfo.reg_no) {
			const cachedVehicleInfo = retrieveVehicleInfo;

			// Check if the reg_no in cache is different from the current input
			// If yes, then clear the old cache
			if (cachedVehicleInfo && cachedVehicleInfo.reg_no && cachedVehicleInfo.reg_no !== vehicleRegNo) {
				console.log("Clearing cache and state");
				clearCacheAndState();
			}
		}

		const cachedAddress = localStorage.getItem("cachedAddress");
		if (cachedAddress) {
			const { postcode: cachedPostcode } = JSON.parse(cachedAddress);
			if (postcode !== cachedPostcode) {
				console.log("Clearing address");
				localStorage.removeItem("cachedAddress");
			}
		}

		if (activeType === "private") {
			if (!idType) {
				showErrorMessage(t(`messages.selectIdType`));
				return;
			}

			if ((idType === "nric" || idType === "NRIC") && idNo) {
				// if (!isNRICValid(idNo)) {
				// 	showErrorMessage(t(`messages.enterValidIdNo`));
				// 	return;
				// }
			}

			if (idType === "passport" && idNo) {
				if(!isPassportValid(idNo)){
					showErrorMessage(t(`messages.enterValidPassportNo`));
					return;
				}
			}
		}

		if (!isPostcodeValid(postcode)) {
			showErrorMessage("Please enter a valid postcode (Must be exactly 5 digits).");
			return;
		}

		if (!vehicleType) {
			showErrorMessage("Please select in Vehicle Type.");
			return;
		}

		if (!vehicleRegNo) {
			showErrorMessage("Please fill in Vehicle Registration No.");
			return;
		}

		if (activeIndex !== 1 && !idNo) {
			showErrorMessage("Please fill in NRIC/Passport No."); 
			return;
		}

		if (!isPostcodeValid(postcode)) {
			showErrorMessage("Please enter a valid postcode (Must be exactly 5 digits).");
			return;
		}

		if (!isValidPostcode(postcode)) {
			showErrorMessage("Invalid postcode. Please enter an existing postcode.");
            return;
		}

		setLoading(true);

		toggleDisabledInputs(activeType, true);

		try {
			let ncdPercent;
			let id_data;
			if (activeIndex === 0 && (idType === "nric" || idType === "NRIC") && idNo && idNo.length === 12) {
				id_data = getDOBFromId(idNo);
			}

			const payload = {
				owner_name: activeIndex === 1 ? companyName : ownerName || "",
				class_code: vehicleType === "Motorcycle" ? "01" : "02",
				veh_reg_no: vehicleRegNo || "",
				id_no: activeIndex === 1 ? businessRegId : activeIndex === 2 ? businessRegId : idNo,
				postcode: postcode || "",
				id_type: activeIndex === 1 ? "business" : activeIndex === 2 ? "business" : idType,
				hphoneno: contactNumber || "",
				enable_bmk: enable_bmk,
				// Ansa-Support#46: send the refusal as its own signal. The server cannot
				// infer it from `enable_bmk: false`, because that same value also means
				// "nobody chose yet" and "this tab never offered BMK" (Commercial) — and
				// recording either of those as a refusal would put words in the
				// customer's mouth. Without this line the refusal is never recorded and
				// a customer who declined is indistinguishable from one who never saw
				// the question.
				bmk_consent_refused: consent_bmk
			};

			const getVehicleDetails = await getVehicleInfo(token, payload);

			// Authoritative server-side gate (ACS Dashboard BRD 3 July 2026): the backend
			// 409s with EARLY_RENEWAL_BLOCKED when this vehicle's in-force policy expires
			// more than 60 days out — show the "Get reminded" form instead of quoting.
			const earlyRenewal =
				getVehicleDetails?.response?.status === 409 &&
				getVehicleDetails?.response?.data?.code === "EARLY_RENEWAL_BLOCKED"
					? getVehicleDetails.response.data.data
					: null;
			if (earlyRenewal) {
				if (earlyRenewal.next_effective_ncd !== null && earlyRenewal.next_effective_ncd !== undefined) {
					setNcd(earlyRenewal.next_effective_ncd);
				}
				setCurrPolExpiryDate(new Date(earlyRenewal.expiry_date));
				setEarliestRenewDate(new Date(earlyRenewal.earliest_renewal_date));
				setReminderName(ownerName || companyName || "");
				setReminderIdNo(activeIndex === 1 || activeIndex === 2 ? businessRegId : idNo);
				setIsModalVisible(true);
				setLoading(false);
				return;
			}

			// A failed vehicle-info call resolves to a normalized error shape with no
			// `data` array — most commonly an expired/absent session token, which the
			// backend returns as 401 "Invalid token" with data:null. Guard here so we
			// surface a clear message instead of crashing on getVehicleDetails.data.some()
			// below (null.some() threw a TypeError that was caught as the generic
			// "We encountered an issue. Please refresh or try again later." dialog).
			if (!getVehicleDetails || getVehicleDetails.success !== true || !Array.isArray(getVehicleDetails.data)) {
				const status =
					getVehicleDetails?.status_code ||
					getVehicleDetails?.response?.status ||
					getVehicleDetails?.response?.data?.status_code;
				if (status === 401 || status === 403) {
					showErrorMessage("Your session has expired. Please log in again.");
				} else {
					showErrorMessage(t(`messages.vehicleDetailsNotFound`));
				}
				toggleDisabledInputs(activeType, false);
				setLoading(false);
				return;
			}

			const insurers = getVehicleDetails?.data || [];
			const mergedVariants = getVehicleDetails?.merged_variants || [];
			const bmk = getVehicleDetails?.bmk || null;

			// Check if any vehicle has expiry_date more than 30 days ago
			const hasInvalidExpiry = getVehicleDetails.data.some((vehicle) => {
				const expiryDate = vehicle.expiry_date ? new Date(vehicle.expiry_date) : null;
				//const expiryDate = new Date("2026-06-09");
			  
				// Ignore if expiry_date is missing or invalid
				if (!expiryDate || isNaN(expiryDate)) return false;
			  
				const today = new Date();
				const diffInDays = (today - expiryDate) / (1000 * 60 * 60 * 24);
			  
				// Stop only if valid date is more than 30 days old
				return diffInDays > 30;
			});

			let expiry_date = "";
			const hasExpiryTooFarAhead = getVehicleDetails.data.some((vehicle) => {
				const expiryDate = vehicle.expiry_date ? new Date(vehicle.expiry_date) : null;
				//const expiryDate = new Date("2026-06-09");

				let vehicle_details = getVehicleDetails.data
					.reduce((shortest, current) => {
						if (current.ncd_perc && current.ncd_perc !== "") {
							ncdPercent = current.ncd_perc;
							setNcd(ncdPercent);
						}
					}, null);

				// Ignore if expiry_date is missing or invalid
				if (!expiryDate || isNaN(expiryDate)) return false;
			
				const earliestRenew = new Date(expiryDate);
				earliestRenew.setDate(expiryDate.getDate() - 60);
			
				const today = new Date();
				const diffInDays = (expiryDate - today) / (1000 * 60 * 60 * 24);
			
				console.log(expiryDate);
				console.log(diffInDays);
				setCurrPolExpiryDate(expiryDate);
				expiry_date = expiryDate;
				setEarliestRenewDate(earliestRenew);
				return diffInDays > 60;
			});
			
			if (hasInvalidExpiry) {
				showErrorMessage(t(`messages.policyMoreThan30Days`));
				toggleDisabledInputs(activeType, false);
				setLoading(false);
				return;
			}

			if (hasExpiryTooFarAhead) {
				//showErrorMessage("You cannot renew as early as <b>60 days</b> before your expiry date.");
				//toggleDisabledInputs(activeType, false);

				const queryParameters = new URLSearchParams(window.location.search);
				const tokenParam = queryParameters.get("token");

				const date = new Date(expiry_date);
				const formatted = date.toISOString().split("T")[0];

				const storeQuote = await storeCacheQuote(tokenParam, {
					reg_no: vehicleRegNo,
					veh_type: vehicleType,
					id_type: idType,
					id_no: idNo,
					business_reg_no: businessRegId,
					company_name: companyName,
					policy_holder_name: ownerName || companyName,
					marital_code: maritalStatus,
					postcode: postcode,
					expiry_date: formatted,
				});

				if (storeQuote.success) {
					if (storeQuote.data && storeQuote.data.cachedQuote) {
						setCachedQuoteId(storeQuote.data.cachedQuote);
					}
					setReminderName(ownerName || companyName || "");
					setReminderIdNo(activeIndex === 1 || activeIndex === 2 ? businessRegId : idNo);
					setIsModalVisible(true);
				} else {
					showErrorMessage(t(`messages.renewAsEarlyAs60Days`));
				}

				setLoading(false);
				return;
			}

			// Check if all records have missing chassis_no and engine_no
			const missingVehicleInfo = getVehicleDetails.data.every(
				(vehicle) => !vehicle.chassis_no && !vehicle.engine_no
			);
			
			if (missingVehicleInfo) {
				showErrorMessage("Cannot find vehicle info in ISM. Please check your registration details.");
				toggleDisabledInputs(activeType, false);
				setLoading(false);
				return;
			}

			if (!getVehicleDetails.data || !Array.isArray(getVehicleDetails.data)) {
				showErrorMessage("Vehicle details not found.");
			}

			setBMKData(getVehicleDetails.bmk);

			let effectiveDate = "";
			let expiredDate = "";

			// Pick the best insurer record to use as base info.
			// Guard variant_series with Array.isArray: a record can carry a valid
			// expiry_date but no variant_series array (e.g. an insurer error/NCD-only
			// record), and an unguarded `.length` on undefined throws a TypeError that
			// surfaces as the generic "We encountered an issue" dialog. The guard makes
			// find() skip such records and fall through to data[0], matching how the
			// backend guards every equivalent access (Array.isArray(r.variant_series)).
			let baseVehicle = getVehicleDetails.data.find(v =>
				v.expiry_date && isDateValid(v.expiry_date) && Array.isArray(v.variant_series) && v.variant_series.length > 0
			) || getVehicleDetails.data[0];

			// Compute expiry dates
			if (baseVehicle && baseVehicle.expiry_date && isDateValid(baseVehicle.expiry_date)) {
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				today.setDate(today.getDate() - 1);

				const currentExpiry = new Date(baseVehicle.expiry_date);
				currentExpiry.setHours(0, 0, 0, 0);

				const baseDate = currentExpiry < today ? today : currentExpiry;

				const baseExpiryDate = new Date(baseDate);
				baseExpiryDate.setDate(baseExpiryDate.getDate() + 1);
				baseExpiryDate.setDate(baseExpiryDate.getDate() + 1);

				const nextExpiryDate = new Date(baseDate);
				nextExpiryDate.setFullYear(nextExpiryDate.getFullYear() + 1);
				nextExpiryDate.setDate(nextExpiryDate.getDate() + 1);

				effectiveDate = baseExpiryDate.toISOString().split("T")[0];
				expiredDate = nextExpiryDate.toISOString().split("T")[0];
			}

			// Use merged variants from backend
			const variantSeries = getVehicleDetails.merged_variants;

			console.log("baseVehicle", baseVehicle);

			if (vehicleRegNo && !baseVehicle) {
				showErrorMessage(t(`messages.vehicleDetailsNotFound`));
			}

			if (getVehicleDetails.success) {
				setVehicleInfo({
					owner_name: ownerName || "",
					companyName: companyName || "",
					id_type:
						activeIndex === 1
							? "business"
							: activeIndex === 2
							? "business"
							: idType,
					id_no:
						activeIndex === 1
							? businessRegId
							: activeIndex === 2
							? businessRegId
							: idNo,
					marital_status: maritalStatus,
					hphoneno: contactNumber || "",
					postcode: postcode || "",
					effective_date: effectiveDate || "",
					expiry_date: expiredDate || "",
					vehicle: (() => {
						const make = baseVehicle.ins_make_desc || "";
						const model = baseVehicle.ins_model_desc || "";
			
						if (
							make.trim().toLowerCase() ===
							model.trim().toLowerCase()
						) {
							return make;
						}
			
						return `${make} ${model}`.trim();
					})(),
					reg_no: baseVehicle.veh_reg_no || "",
					ownership_type:
					activeIndex === 0
						? "I"
						: activeIndex === 1
						? "B"
						: activeIndex === 2
						? "B"
						: "I",
					veh_type:
						vehicleType === "Motorcycle" ? "motorcycle" : "car",
					make_year: baseVehicle.make_year || "",
					vehicle_details: baseVehicle,
					// IMPORTANT: USE MERGED VARIANTS
					ncd_percent: baseVehicle.ncd_perc,
					variant_series: mergedVariants || [],
				});
			
				navigate(`/get-quote/select-car-variant`);
			} else {
				showErrorMessage("Vehicle details not found.");
			}
		} catch (error) {
			console.log("THIS IS ERROR: ", error);
			showErrorMessage("We encountered an issue. Please refresh or try again later.");
		} finally {
			toggleDisabledInputs(activeType, false);
			setLoading(false);
		}
	};

	const proceedToSelectPlan = () => {
		navigate(`/get-quote/select-car-plan`);
	};

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			showErrorMessage("Invalid ID number format");
			return;
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);

		if (isNaN(date)) return ""; // handle invalid date

		const day = String(date.getDate()).padStart(2, "0");

		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC",
		];

		const month = months[date.getMonth()];
		const year = date.getFullYear();

		return `${day}-${month}-${year}`;
	}

	const handleRemindMeClick = async (e) => {
		e.preventDefault();

		if (!reminderName || !reminderName.trim()) {
			showErrorMessage(`Please enter the full owner name.`);
			return;
		}
		if (!reminderIdNo || !reminderIdNo.trim()) {
			showErrorMessage(`Please enter the owner ID number.`);
			return;
		}
		if (!email || !/^\S+@\S+\.\S+$/.test(email.trim())) {
			showErrorMessage(`Please enter a valid email address.`);
			return;
		}
		if (!reminderPhone || !/^\+?[0-9][0-9\s-]{6,19}$/.test(reminderPhone.trim())) {
			showErrorMessage(`Please enter a valid contact number.`);
			return;
		}

		try {
			setReminderSubmitting(true);
			const queryParameters = new URLSearchParams(window.location.search);
			const tokenParam = queryParameters.get("token");

			// Persists the BRD "Get reminded to renew your insurance" record server-side;
			// the backend re-derives the expiry from the in-force policy and schedules the
			// 60/30/14/7/1-day push+email countdown (the sent date here is only a fallback).
			const payloads = {
				full_name: reminderName.trim(),
				id_number: reminderIdNo.trim(),
				vehicle_reg_no: vehicleRegNo,
				email: email.trim(),
				contact_no: reminderPhone.trim(),
				next_effective_ncd: ncdPerc,
				expiry_date: currPolExpiryDate
					? new Date(currPolExpiryDate).toISOString().split("T")[0]
					: "",
			};
			const response = await createEarlyRenewalReminder(tokenParam, payloads);

			if (response.success) {
				localStorage.setItem("reminderData", JSON.stringify({
					reg_no: vehicleRegNo,
					ncd_percent: ncdPerc,
					currPolExpiryDate,
					earliestRenewDate,
				}))

				navigate("/reminder-summary", {
					replace: true
				});


			} else {
				showErrorMessage(response.message || response?.response?.data?.message || t(`messages.somethingWentWrong`));
				return;
			}
		} catch (error) {
			console.log("Remind me ERROR: ", error);
			showErrorMessage(t(`messages.somethingWentWrong`));
		} finally {
			setReminderSubmitting(false);
		}
	};

	const handleSkipForNow = async (e) => {
		e.preventDefault();

		setIsModalVisible(false);
		showInfo(t(`messages.noProblem`), t(`messages.continueExploringOtherVehicle`));
	};

	return (
		<>
			{ loading && <Loader2 /> }

			<div className="content">
				<div className="get-quote-container d-m-column vw-50">
					{/* Right Section */}
					<div className="get-quote-form-section w-100">
						<div className="get-quote-image-section">
							<img
								className="get-quote-banner"
								src={getQuoteBanner}
								alt="get-quote-banner"
								loading="lazy"
								style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
							/>
						</div>

						<div className="d-flex flex-row justify-content-between w-100 mt-10">
							<div className="w-70 text-left">
								<h3 className="mt-0 mb-0">{`Find the best auto insurance in seconds`}</h3>
							</div>
							<div className="w-30 text-right">
								<span className="color-primary underline" onClick={clearFields}>
									{"Clear Fields"}
								</span>
							</div>
							<p className="formatted-text">{`Affordable Car Insurance & Motorcycle Insurance for Malaysians!`}</p>
						</div>

						<TabView
							activeIndex={activeIndex}
							onTabChange={(e) => onTabChange(e)}
							className="p-m-20 w-100"
						>
							<TabPanel header="Private">
								{activeIndex === 0 && (
									<form className="form-input-get-quote w-100">
										<div className="flex flex-wrap gap-3">
											<label>{`Type: `}</label>
											<div className="radio-group">
												<RadioButton
													inputId="car"
													name="car"
													value="Private Car"
													onChange={(e) => setVehicleType(e.value)}
													checked={vehicleType === "Private Car"}
													disabled={!!disabledInputs?.private?.typePrivateCar}
												/>
												<label htmlFor="car" className="ml-2">
													Private Car
												</label>
											</div>
											<div className="radio-group">
												<RadioButton
													inputId="motorcycle"
													name="motorcycle"
													value="Motorcycle"
													onChange={(e) => setVehicleType(e.value)}
													checked={vehicleType === "Motorcycle"}
													disabled={!!disabledInputs?.private?.typeMotorCycle}
												/>
												<label htmlFor="motorcycle" className="ml-2">
													Motorcycle
												</label>
											</div>
										</div>

										<div className="form-input-get-quote-group">
											<div className="row justify-content-between mx-0">
												<div className="col-lg-6 input-group">
													<FloatLabelInput
														label={
															<>
																Vehicle Registration No.<span className="required-asterisk">*</span>
															</>
														}
														value={vehicleRegNo}
														onChange={handleVehRegNo}
														style={{ textTransform: 'uppercase' }}
														placeholder=""
														disabled={!!disabledInputs?.private?.vehicleRegNo}
													/>
												</div>

												<div className="col-lg-6 input-group">
													<FloatingSelectIdentity
														label={
															<>
																ID Type<span className="required-asterisk">*</span>
															</>
														}
														options={idTypeOptions}
														value={idType}
														onChange={handleIdTypeSelectChange}
														disabled={!!disabledInputs?.private?.typeOfIdentity}
													/>
												</div>

												<div className="col-lg-6 input-group">
													<FloatLabelInput
														label={
														<>
															{idType === 'passport' ? 'Passport Number' : 'Identification Number'}
															<span className="required-asterisk">*</span>
														</>
														}
														value={idNo}
														onChange={handleInputChange}
														uppercase
														placeholder=""
														disabled={!!disabledInputs?.private?.idNo}
													/>
												</div>
											</div>

											{idType === 'passport' && (
												<div className="row justify-content-between mx-0">
													<div className="col-lg-6 col-sm-6 input-group">
														<FloatDateInput
															label="Date of Birth"
															value={dob}
															onChange={(e) => setDob(e.value)}
															dateFormat="dd-mm-yy"
															showIcon
															disabled={!!disabledInputs?.private?.dob}
														/>
													</div>
													<div className="col-lg-6 col-sm-6 input-group">
														<div className="float-label-input">
															<input
																type="text"
																id="age-input-id"
																className="age-input-field"
																value={calculateAge(dob)}
																readOnly
																disabled={!!disabledInputs?.private?.age}
															/>
															<label htmlFor="age-input-id">Age</label>
														</div>
													</div>

												</div>
												
											)}

											<div className="input-group">
												<FloatLabelInput
													label={
														<>
															Owner Name (As per ID)<span className="required-asterisk">*</span>
														</>
													}
													value={ownerName}
													onChange={handleNameChange(setOwnerName)}
													placeholder=""
													disabled={!!disabledInputs?.private?.ownerName}
												/>
											</div>

											<div className="col-lg-6 input-group">
												<FloatingSelectIdentity
													label={
														<>
															{t(`common.maritalStatus`)}<span className="required-asterisk">*</span>
														</>
													}
													options={maritalStatusOptions}
													value={maritalStatus}
													onChange={handleMaritalStatusSelectChange}
													disabled={!!disabledInputs?.private?.typeOfIdentity}
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={
														<>
															Postcode<span className="required-asterisk">*</span>
														</>
													}
													value={postcode}
													onChange={handlePostcodeChange}
													placeholder=" "
													disabled={!!disabledInputs?.private?.postcode}
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={
														<>
															Contact Number<span className="required-asterisk">*</span>
														</>
													}
													value={contactNumber}
													onChange={handleContactNumberChange}
													placeholder=""
													disabled={!!disabledInputs?.private?.postcode}
												/>
											</div>
											<div
												className="input-group d-flex gap-2 flex-row justify-content-between">
												<Checkbox
													inputId={`bmk`}
													checked={enable_bmk}
													disabled={consent_bmk}
													onChange={(e) => handleCheckboxChange(e)}
												/>
												<label
													htmlFor={`bmk`}
													className="flex-1"
													style={{wordBreak:'break-word'}}
													>
													I hereby provide full consent and authorisation to Ansa Digital Sdn. Bhd, a company appointed by Jabatan Pengangkutan Jalan Malaysia (JPJ) to access, use, and verify my Butiran Maklumat Kenderaan (BMK) for the sole purpose of processing and renewing my motor insurance.
												</label>
											</div>
											<div
												className="input-group d-flex gap-2 flex-row justify-content-between">
												<Checkbox
													inputId={`bmk_consent`}
													checked={consent_bmk}
													disabled={enable_bmk}
													onChange={(e) => handleConsentChange(e)}
												/>
												<label
													htmlFor={`bmk_consent`}
													className="flex-1"
													style={{wordBreak:'break-word'}}
													>
													I hereby do not provide consent to Ansa Digital Sdn. Bhd to access, use, or verify my Butiran Maklumat Kenderaan (BMK) in relation to my motor insurance renewal.
												</label>
											</div>
										</div>

										<Button
											label="Get Quote Now"
											className="get-quote-button"
											loading={loading}
											disabled={!vehicleType || !vehicleRegNo || !idNo || !ownerName || !postcode || !contactNumber || !bmkChoiceMade}
											onClick={(e) => handleButtonClick(e)}
											size="large"
										/>
									</form>
								)}
							</TabPanel>
							<TabPanel header="Company">
								{activeIndex === 1 && (
									<form className="form-input-get-quote w-100">
										{/* <input
											type="hidden"
											value="Company"
										/> */}
										<div className="flex flex-wrap gap-3">
											<label>{`Vehicle Type: `}</label>
											<div className="flex align-items-center">
												<RadioButton
													inputId="car"
													name="car"
													value="Car"
													onChange={(e) => setVehicleType(e.value)}
													checked={vehicleType === "Car"}
												/>
												<label htmlFor="car" className="ml-2">
													Car
												</label>
											</div>
											<div className="flex align-items-center">
												<RadioButton
													inputId="motorcycle"
													name="motorcycle"
													value="Motorcycle"
													onChange={(e) => setVehicleType(e.value)}
													checked={vehicleType === "Motorcycle"}
												/>
												<label htmlFor="motorcycle" className="ml-2">
													Motorcycle
												</label>
											</div>
										</div>

										<div className="form-input-get-quote-group">
											<div className="row justify-content-between mx-0">
												<div className="col-lg-6 input-group">
													<FloatLabelInput
														label={`Vehicle Registration No.`}
														value={vehicleRegNo}
														onChange={handleVehRegNo}
														style={{ textTransform: 'uppercase' }}
														placeholder=""
													/>
												</div>

												<div className="col-lg-6 input-group">
                          <FloatLabelInput
                            label={`Business Registration ID`}
                            value={businessRegId}
                            onChange={(e) => setBusinessRegId(e.target.value)}
                            uppercase
                            placeholder=""
                          />
												</div>
											</div>

											{/* <div className="input-group">
												<FloatLabelInput
													label={`Owner Name (As per ID)`}
													value={ownerName}
													onChange={(e) => setOwnerName(e.target.value)}
													placeholder=""
												/>
											</div> */}

											<div className="input-group">
												<FloatLabelInput
													label={`Company Name`}
													value={companyName}
													onChange={handleNameChange(setCompanyName)}
													placeholder=""
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={`Postcode`}
													value={postcode}
													onChange={(e) => setPostcode(e.target.value)}
													placeholder=" "
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={`Contact Number`}
													value={contactNumber}
													onChange={handleContactNumberChange}
													placeholder=""
												/>
											</div>

											<div
												className="input-group d-flex gap-2 flex-row justify-content-between">
												<Checkbox
													inputId={`bmk_company`}
													checked={enable_bmk}
													disabled={consent_bmk}
													onChange={(e) => handleCheckboxChange(e)}
												/>
												<label
													htmlFor={`bmk_company`}
													className="flex-1"
													style={{wordBreak:'break-word'}}
													>
													I hereby provide full consent and authorisation to Ansa Digital Sdn. Bhd, a company appointed by Jabatan Pengangkutan Jalan Malaysia (JPJ) to access, use, and verify my Butiran Maklumat Kenderaan (BMK) for the sole purpose of processing and renewing my motor insurance.
												</label>
											</div>
											<div
												className="input-group d-flex gap-2 flex-row justify-content-between">
												<Checkbox
													inputId={`bmk_consent_company`}
													checked={consent_bmk}
													disabled={enable_bmk}
													onChange={(e) => handleConsentChange(e)}
												/>
												<label
													htmlFor={`bmk_consent_company`}
													className="flex-1"
													style={{wordBreak:'break-word'}}
													>
													I hereby do not provide consent to Ansa Digital Sdn. Bhd to access, use, or verify my Butiran Maklumat Kenderaan (BMK) in relation to my motor insurance renewal.
												</label>
											</div>
										</div>

										<Button
											label="Get Quote Now"
											className="get-quote-button"
											loading={loading}
											disabled={!vehicleType || !vehicleRegNo || !postcode || !contactNumber || !bmkChoiceMade}
											onClick={(e) => handleButtonClick(e)}
											size="large"
										/>
									</form>
								)}
							</TabPanel>
							<TabPanel header="Commercial">
								{activeIndex === 2 && (
									<form className="form-input-get-quote w-100">
										{/* <input
											type="hidden"
											value="Commercial"
										/> */}
										<div className="flex flex-wrap gap-3">
											<label>{`Type: `}</label>
											<div className="flex align-items-center">
												<RadioButton
													inputId="car"
													name="car"
													value="Commercial Vehicle"
													onChange={(e) => setVehicleType(e.value)}
													checked={vehicleType === "Commercial Vehicle"}
												/>
												<label htmlFor="car" className="ml-2">
													Commercial Vehicle
												</label>
											</div>
										</div>

										<div className="form-input-get-quote-group">
											<div className="row justify-content-between mx-0">
												<div className="col-lg-6 input-group">
													<FloatLabelInput
														label={`Vehicle Registration No.`}
														value={vehicleRegNo}
														onChange={handleVehRegNo}
														style={{ textTransform: 'uppercase' }}
														placeholder=""
													/>
												</div>

												<div className="col-lg-6 input-group">
													<FloatLabelInput
														label={`NRIC/ Passport No.`}
														value={idNo}
														onChange={(e) => setIdNo(e.target.value)}
														uppercase
														placeholder=""
													/>
												</div>
											</div>

											{/*<div className="input-group">
												<FloatLabelInput
													label={`Owner Name (As per ID)`}
													value={ownerName}
													onChange={(e) => setOwnerName(e.target.value)}
													placeholder=""
												/>
											</div>*/}

											<div className="input-group">
												<FloatLabelInput
													label={`Business Registration ID`}
													value={businessRegId}
													onChange={(e) => setBusinessRegId(e.target.value)}
													uppercase
													placeholder=""
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={`Company Name`}
													value={companyName}
													onChange={handleNameChange(setCompanyName)}
													placeholder=""
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={`Postcode`}
													value={postcode}
													onChange={(e) => setPostcode(e.target.value)}
													placeholder=" "
												/>
											</div>

											<div className="input-group">
												<FloatLabelInput
													label={`Contact Number`}
													value={contactNumber}
													onChange={handleContactNumberChange}
													placeholder=""
												/>
											</div>
										</div>

										<Button
											label="Get Quote Now"
											className="get-quote-button"
											loading={loading}
											disabled={!vehicleType || !vehicleRegNo || !idNo || !postcode || !maritalStatus || !contactNumber}
											onClick={(e) => handleButtonClick(e)}
											size="large"
										/>
									</form>
								)}
							</TabPanel>
						</TabView>
					</div>

					{/* BottomMessagePopUp Component */}
					<Suspense>
						<BottomMessagePopUp
							message={message}
							type="error"
							isVisible={isMessageVisible}
							onClose={() => setIsMessageVisible(false)}
						/>
					</Suspense>

					<Dialog
						className="filter-modal d-flex flex-row bg-white p-4 py-5 gap-2"
						modal
						header={`Filters`}
						visible={isModalVisible}
						style={{
							borderRadius: "24px 24px 0 0",
							margin: 0,
							width: "100vw",
							overflowY: "auto",
						}}
						position={"bottom"}
						content={({ hide }) => (
							<>
								<div className="filters w-100">
									{/* Red banner — ACS Dashboard BRD mockup */}
									<div
										className="d-flex align-items-center justify-content-between mb-3"
										style={{
											backgroundColor: "#B3282D",
											borderRadius: "16px",
											padding: "20px",
											gap: "12px",
										}}
									>
										<span
											style={{
												color: "#ffffff",
												fontSize: "18px",
												lineHeight: "24px",
												fontWeight: 500,
											}}
											dangerouslySetInnerHTML={{
												__html: `You can renew as early as <b>60 days</b> before your expiry date`,
											}}
										/>
										<img
											src={reminderCalendar}
											alt="calendar"
											loading="lazy"
											style={{
												objectFit: "contain",
												width: "72px",
												height: "auto",
												flexShrink: 0,
											}}
										/>
									</div>
									<div
										className="select-variant-container mb-2 p-0"
										style={{ maxHeight: "100vh", overflow: "auto" }}
									>
										<div className="owner-info">
											<div className="card text-left">
												<div className="owner-info-row p-0">
													<span style={{ flex: "inherit", fontSize: "14px", lineHeight: "20px" }}>
														{`Your next effective NCD:`}
													</span>
													<strong style={{ fontSize: "14px", lineHeight: "20px" }}>
														{ncdPerc !== null && ncdPerc !== "" && !isNaN(parseFloat(ncdPerc))
															? `${parseFloat(ncdPerc)}%`
															: `-`}
													</strong>
												</div>
												<div className="owner-info-row p-0">
													<span style={{ flex: "inherit", fontSize: "14px", lineHeight: "20px" }}>
														{`Current policy's expiry date:`}
													</span>
													<strong style={{ fontSize: "14px", lineHeight: "20px" }}>{`${formatDate(currPolExpiryDate)}`}</strong>
												</div>
												<div className="owner-info-row p-0">
													<span style={{ flex: "inherit", fontSize: "14px", lineHeight: "20px" }}>
														{`Earliest date to renew:`}
													</span>
													<strong style={{ fontSize: "14px", lineHeight: "20px" }}>{`${formatDate(earliestRenewDate)}`}</strong>
												</div>
											</div>
										</div>
									</div>
									<div
										style={{
											backgroundColor: "#F5F5F7",
											borderRadius: "12px",
											padding: "16px",
										}}
									>
										<h5 className="m-0 mb-2 fw-bold" style={{ fontSize: "16px" }}>
											{`Get reminded to renew your insurance`}
										</h5>
										<div className="mb-2">
											<span style={{ fontSize: "14px", display: "block" }}>
												{t(`common.vehicleRegistrationNo`)}
											</span>
											<strong style={{ fontSize: "14px" }}>{vehicleRegNo}</strong>
										</div>
										<FloatLabelInput
											label={`Full Name`}
											value={reminderName}
											onChange={(e) => setReminderName(e.target.value)}
											placeholder="e.g.: Andy Tan"
										/>
										<FloatLabelInput
											label={`Owner ID Number`}
											value={reminderIdNo}
											onChange={(e) => setReminderIdNo(e.target.value)}
											placeholder=""
										/>
										<FloatLabelInput
											label={t(`common.emailAddress`)}
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											placeholder="e.g.: username@domain.com"
										/>
										<FloatLabelInput
											label={`Phone Number`}
											value={reminderPhone}
											onChange={(e) => setReminderPhone(e.target.value)}
											placeholder="e.g.: 012888XXXX"
										/>
										<span className="formatted-text" style={{ fontSize: "12px", fontStyle: "italic" }}>
											You'll receive reminder notifications through the ANSA App and email before your renewal date.
										</span>
									</div>
								</div>
								<div className="d-flex w-100 gap-2 mt-3">
									<Button
										className="fw-bold w-50"
										label={`Cancel`}
										style={{
											backgroundColor: "transparent",
											border: "1px solid #B3282D",
											color: "#B3282D",
											borderRadius: "24px",
										}}
										onClick={(e) => handleSkipForNow(e)}
									/>
									<Button
										className="fw-bold w-50"
										label={`Remind me`}
										disabled={reminderSubmitting}
										style={{
											backgroundColor: "#B3282D",
											border: "1px solid #B3282D",
											color: "#ffffff",
											borderRadius: "24px",
											opacity: reminderSubmitting ? 0.6 : 1,
										}}
										onClick={(e) => handleRemindMeClick(e)}
									/>
								</div>
							</>
						)}
					></Dialog>
				</div>
			</div>
		</>
	);
};

export default GetQuotes;